import { getDefaultExportFromCjs as s } from "./_commonjsHelpers.mjs";
import { __require as r } from "../node_modules/classnames/index.mjs";
var a = r();
const t = /* @__PURE__ */ s(a);
export {
  t as default
};
